import React from "react";

function EventNameField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="event-name">
                Event Name <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <input
                className="oct-shared-popup__input"
                id="event-name"
                value={value}
                autoComplete="off"
                disabled={disabled}
                placeholder="Enter event name"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}

export default EventNameField;
